import { render, staticRenderFns } from "./lawsRegulations.vue?vue&type=template&id=1fcbd19a"
import script from "./lawsRegulations.vue?vue&type=script&lang=js"
export * from "./lawsRegulations.vue?vue&type=script&lang=js"
import style0 from "./lawsRegulations.vue?vue&type=style&index=0&id=1fcbd19a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports